import React from 'react';

/**
 * Custom hook to manage body overflow when modals are open/closed
 * This ensures scroll is properly restored when modals close
 */
export const useModalBodyOverflow = (isOpen: boolean) => {
  React.useEffect(() => {
    if (!isOpen) document.body.style.overflow = 'unset';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  // Function to manually reset overflow (useful before navigation)
  const resetBodyOverflow = () => {
    document.body.style.overflow = 'unset';
  };

  return { resetBodyOverflow };
};
